<template>        
    <termsConditionsComponents :termsConditions="termsConditions"/>    
</template>
  
  <script>
  import termsConditionsComponents from './components/terms_conditions_component.vue';
  
  export default {
    name: 'termsConditions',
    components: {
      termsConditionsComponents,
    },
    props: {
      termsConditions: {
        required: true,
        type: Boolean
      },
    },
  }
  </script>
  
  <style lang="css" scoped>
  
  </style>

  